import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const editClinicTestMasterTestByTestId = createAsyncThunk(
  "clinicTestMaster/editClinicTestMasterTestByTestId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicTestMaster/editClinicTestMasterTestByTestId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteTestFromClinicTestMaster = createAsyncThunk(
  "clinicTestMaster/deleteTestFromClinicTestMaster",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicTestMaster/deleteTestFromClinicTestMaster",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getClinicTestMasterByClinicId = createAsyncThunk(
  "clinicTestMaster/getClinicTestMasterByClinicId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinicTestMaster/getClinicTestMasterByClinicId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getClinicTestMasterTestDetailsByTestId = createAsyncThunk(
  "clinicTestMaster/getClinicTestMasterTestDetailsByTestId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinicTestMaster/getClinicTestMasterTestDetailsByTestId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

const initialState = {
  loading: false,
  clinicTestMasterTestInfo: [],
  clinicTestMasterByClinicId: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  limit: 9,
  searchMessage: null,
  editClinicTestMasterTestByTestIdSuccessMessage: null,
  editClinicTestMasterTestByTestIdErrorMessage: null,
  deleteTestinClinicTestMasterSuccessMessage: null,
  deleteTestinClinicTestMasterErrorMessage: null,
};

const citySlice = createSlice({
  name: "clinicTestMaster",
  initialState,
  reducers: {
    resetEditClinicTestMasterTestByTestIdMessage: (state) => {
      state.editClinicTestMasterTestByTestIdSuccessMessage = null;
      state.editClinicTestMasterTestByTestIdErrorMessage = null;
    },
    resetDeleteTestinClinicTestMasterMessage: (state) => {
      state.deleteTestinClinicTestMasterSuccessMessage = null;
      state.deleteTestinClinicTestMasterErrorMessage = null;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageLimit: (state, action) => {
      state.limit = action.payload;
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editClinicTestMasterTestByTestId.pending, (state) => {
        state.loading = true;
        state.editClinicTestMasterTestByTestIdSuccessMessage = null;
        state.editClinicTestMasterTestByTestIdErrorMessage = null;
      })
      .addCase(editClinicTestMasterTestByTestId.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.editClinicTestMasterTestByTestIdErrorMessage =
            action.payload.result.message;
        } else {
          state.editClinicTestMasterTestByTestIdSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(editClinicTestMasterTestByTestId.rejected, (state, action) => {
        state.loading = false;
        state.editClinicTestMasterTestByTestIdErrorMessage =
          action.payload.result.message;
      })
      .addCase(deleteTestFromClinicTestMaster.pending, (state) => {
        state.loading = true;
        state.deleteTestinClinicTestMasterSuccessMessage = null;
        state.deleteTestinClinicTestMasterErrorMessage = null;
      })
      .addCase(deleteTestFromClinicTestMaster.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteTestinClinicTestMasterErrorMessage =
            action.payload.result.message;
        } else {
          state.deleteTestinClinicTestMasterSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(deleteTestFromClinicTestMaster.rejected, (state, action) => {
        state.loading = false;
        state.deleteTestinClinicTestMasterErrorMessage =
          action.payload.result.message;
      })
      .addCase(getClinicTestMasterByClinicId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClinicTestMasterByClinicId.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
          state.clinicTestMasterByClinicId = [];
        } else {
          state.clinicTestMasterByClinicId = action.payload.result.list;
          state.searchMessage = null;
        }
      })
      .addCase(getClinicTestMasterByClinicId.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getClinicTestMasterTestDetailsByTestId.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getClinicTestMasterTestDetailsByTestId.fulfilled,
        (state, action) => {
          state.loading = false;
          state.clinicTestMasterTestInfo = action.payload.result.list;
        },
      )
      .addCase(
        getClinicTestMasterTestDetailsByTestId.rejected,
        (state, action) => {
          state.loading = false;
        },
      );
  },
});

export const {
  resetDeleteTestinClinicTestMasterMessage,
  resetEditClinicTestMasterTestByTestIdMessage,
  setCurrentPage,
  setPageLimit,
} = citySlice.actions;

export default citySlice.reducer;
